import { render, staticRenderFns } from "./happinessFoundationIDCard.vue?vue&type=template&id=33b55df0&scoped=true&"
import script from "./happinessFoundationIDCard.vue?vue&type=script&lang=js&"
export * from "./happinessFoundationIDCard.vue?vue&type=script&lang=js&"
import style0 from "./happinessFoundationIDCard.vue?vue&type=style&index=0&id=33b55df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b55df0",
  null
  
)

export default component.exports